export enum ManualTrailStatusRelations {
  trail = 'trail',
  system = 'system',
}
